// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import { Button } from 'vant';
import router from '@/router';
import store from '@/store';
import * as echarts from 'echarts';
import Bus from '@/util/bus';
import shareData from '@/util/shareData';
// import ScrollAnimation from '@/util/flyBottomIn';
import App from './App';
Vue.use(Button);

Vue.config.productionTip = false;

// Vue.directive('flyBottomIn', ScrollAnimation);

Object.defineProperty(Vue.prototype, '$Bus', { value: Bus });
Object.defineProperty(Vue.prototype, '$shareData', { value: shareData });
Object.defineProperty(Vue.prototype, '$echarts', { value: echarts });


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});

router.beforeEach((to, from, next) => {
    console.log(`main.js[28] to: ${to}}`);
    console.log(`main.js[29] from: ${from}`);
    document.documentElement.scrollTop = 0;

    next(true);
});

router.afterEach((route) => {
    console.log(route);

    // Vue.nextTick(() => {
    //     if (route.path === '/home') {
    //         // do something
    //     }
    // });
});



// WEBPACK FOOTER //
// ./src/main.js